import React from 'react';
import { QueryRenderer, graphql } from 'react-relay';
import { getBuyerId } from 'dibs-cookie-jar';
import { addLoginHandlers } from 'dibs-buyer-layout/src/utils/loginHandlers';
import get from 'lodash.get';

import { Error, Loader } from '../shared';
import { getEnvironment } from '../relayModernEnvironment';
import LoyaltyModulesWrapper from './LoyaltyModulesWrapper';

export default class LoyaltyModulesContainer extends React.Component {
    constructor(props) {
        super(props);
        this.state = { userId: getBuyerId(document.cookie) };
    }

    componentDidMount() {
        addLoginHandlers(() => {
            const newUserId = getBuyerId(document.cookie);
            if (newUserId !== this.state.userId) {
                this.setState({
                    userId: newUserId,
                });
            }
        });
    }

    render() {
        const { userId } = this.state;
        const containerProps = this.props;

        return (
            <QueryRenderer
                environment={getEnvironment()}
                query={graphql`
                    query LoyaltyModulesContainerQuery($userId: String!, $hasUserId: Boolean!) {
                        viewer {
                            ...LoyaltyModulesWrapper_viewer
                            user(userId: $userId) @include(if: $hasUserId) {
                                ...LoyaltyModulesWrapper_user
                            }
                        }
                    }
                `}
                variables={{ userId: userId || '', hasUserId: !!userId }}
                render={({ props, error }) => {
                    const viewer = get(props, 'viewer') || null;
                    const user = get(props, 'viewer.user') || null;

                    if (error) {
                        return <Error />;
                    } else if (props) {
                        return (
                            <LoyaltyModulesWrapper
                                {...containerProps}
                                {...props}
                                user={user}
                                viewer={viewer}
                            />
                        );
                    }

                    return <Loader />;
                }}
            />
        );
    }
}
